<div class="flex flex-col items-stretch overflow-auto">
    <ng-container *ngIf="(tableOptions?.data$ | async) as data">
        <table class="text-zen-primaryLight w-full border-seperate" cdk-table [dataSource]="data">
            @for (column of tableOptions.columns; track column.field; let i = $index) {
            <ng-container [cdkColumnDef]="column.field">
                <th [hidden]="tableOptions.disableHeader" class="text-2.5xs font-medium uppercase px-4 text-start"
                    cdk-header-cell *cdkHeaderCellDef>
                    @if (tableOptions.selection && !i) {
                        <a (click)="masterToggle()">
                            <i class="text-xl btn" [ngClass]="tableSelection.all ? 'fa-solid fa-square-check text-exp' : 'fa-regular fa-square'"></i>
                        </a>
                    } @else {
                        {{ localize(column.name, language, module) }}
                    }
                </th>
                <td class="text-xs transition-all ease-expo font-normal px-4 text-start bg-white bg-opacity-50 h-12"
                    cdk-cell *cdkCellDef="let row; let rowIndex = index">
                    @if (tableOptions.selection && !i && !tableOptions?.selectionRemove?.includes(row[tableOptions?.selectionRemoveKey])) {
                        <a (click)="singleToggle(row)"><i class="btn text-xl" [ngClass]="isRowSelected(row) ? 'fa-solid fa-square-check text-exp' : 'fa-regular fa-square'"></i></a>
                    } @else {
                        <ng-container
                            *ngTemplateOutlet="cellTemplate; context: { $implicit: row, column: column.field, index: i, rowIndex }"></ng-container>
                    }
                </td>
            </ng-container>
            }
            <tr [hidden]="tableOptions.disableHeader" class="h-12" cdk-header-row
                *cdkHeaderRowDef="getRows(tableOptions.columns)"></tr>
            <tr [@rowlistAnimation]="data?.length"  class="text-zen-primaryLight hover:text-zen transition-all h-16 border-b border-zen border-opacity-10" cdk-row
                *cdkRowDef="let row; columns: getRows(tableOptions.columns)"></tr>
            <tr class="cdk-row" *cdkNoDataRow>
                <td [colSpan]="tableOptions.columns?.length">
                    <div #emptyContentImg [hidden]="emptyContentImg.innerHTML?.length == 0"
                        class="flex flex-row justify-center w-full">
                        <ng-content select="[emptyRowImage]"></ng-content>
                    </div>
                    <div *ngIf="emptyContentImg?.innerHTML?.length === 0"
                        class="flex flex-row justify-center w-full">
                        <lottie-player [src]="search" background="transparent" speed="1"
                            style="width: 18rem; height: 18rem;" autoplay></lottie-player>
                    </div>
                    <div #emptyContentMsg [hidden]="emptyContentMsg.innerHTML?.length == 0"
                        class="flex flex-row justify-center">
                        <ng-content select="[emptyRowMessage]"></ng-content>
                    </div>
                    <div *ngIf="emptyContentMsg?.innerHTML?.length === 0" class="flex flex-row justify-center">
                        <span class="text-sm text-zen-primaryLight">
                            {{ localize('txtNoDataAvailable',language,ModuleNames.Shared) }}
                        </span>
                    </div>
                </td>
            </tr>
        </table>
    </ng-container>

    <div *ngIf="tableOptions?.pagination"
        class="flex flex-row bg-transparent items-center rounded-md h-14 self-center relative w-full px-4">
        <div *ngIf="totalPages?.length" class="flex flex-row text-zen text-xs whitespace-nowrap">
            <span class="text-zen-primaryLight">{{ localize('Pages',language,ModuleNames.Shared) }}: </span>
            {{ totalPages.length }}
        </div>
        <div class="h-14 flex flex-row bg-transparent justify-center w-full pag-buttons">
            <div (click)="goToChange(0)" class="h-full flex flex-col justify-center cursor-pointer"
                *ngIf="pageIndex > 2">
                <a class="btn leading-10 w-10 text-center mx-1 rounded-md">
                    <i [ngClass]="!rtl ? 'fa-angle-double-left' : 'fa-angle-double-right'"
                        class="fal text-zen text-xl leading-10"></i>
                </a>
            </div>
            <div (click)="goToChange(pageIndex - 1)" class="h-full flex flex-col justify-center cursor-pointer"
                *ngIf="pageIndex > 1">
                <a class="btn leading-10 w-10 text-center mx-1 rounded-md">
                    <i [ngClass]="!rtl ? 'fa-angle-left' : 'fa-angle-right'"
                        class="fal text-zen text-xl leading-10"></i>
                </a>
            </div>
            <div class="h-full flex flex-col justify-center" *ngFor="let pageNumber of totalPages; let i = index">
                <a *ngIf="i === pageIndex || i + 1 === pageIndex || i - 1 === pageIndex" (click)="goToChange(i)"
                    [ngClass]="i === pageIndex ? 'primary' : 'secondary'"
                    class="btn leading-10 w-10 text-center mx-1 rounded-md cursor-pointer text-white">
                    {{ pageNumber }}
                </a>
            </div>
            <div (click)="goToChange(pageIndex + 1)" class="h-full flex flex-col justify-center cursor-pointer"
                *ngIf="pageIndex < totalPages.length - 2">
                <a class="btn leading-10 w-10 text-center mx-1 rounded-md">
                    <i [ngClass]="!rtl ? 'fa-angle-right' : 'fa-angle-left'"
                        class="fal text-zen text-xl leading-10"></i>
                </a>
            </div>
            <div (click)="goToChange(totalPages.length - 1)" class="h-full flex flex-col justify-center cursor-pointer"
                *ngIf="pageIndex < totalPages.length - 3">
                <a class="btn leading-10 w-10 text-center mx-1 rounded-md">
                    <i [ngClass]="!rtl ? 'fa-angle-double-right' : 'fa-angle-double-left'"
                        class="fal text-zen text-xl leading-10"></i>
                </a>
            </div>
        </div>
        <h5 class="text-zen text-xs whitespace-nowrap" *ngIf="totalRecords">
            <span class="text-zen-primaryLight">{{ 'txtTotal' | translate:language:ModuleNames.Shared }}: </span> {{ totalRecords
            }}
        </h5>
    </div>
</div>